import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
    const { user } = useAuth();

    const hasPermission = (permissionCode) => {
        // Fallbacks iniciales de protección
        if (!user) return false;
        
        // El superuser tiene acceso irrestricto a todo el sistema
        if (user.is_superuser) return true;

        // El personal de staff (Administradores) tiene acceso a las vistas de gestión
        // Esto coincide con el comportamiento del backend que permite is_staff para estas acciones
        if (user.is_staff) return true;

        // Si la ruta/ítem no requiere un código de permiso en particular, lo permitimos por defecto 
        if (!permissionCode) return true;

        // Si el usuario trae su lista de permisos (ej. ['orders.add_order', ...]) lo verificamos
        if (user.permissions && Array.isArray(user.permissions)) {
            // Permitimos si tiene el permiso exacto
            return user.permissions.includes(permissionCode);
        }

        // Si no cumple nada, rechazamos acceso al recurso
        return false;
    };

    return { hasPermission };
};
